<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <div>
        <v-card>
          <v-layout>
            <v-flex class="xs12">
              <v-card-text>
                <yandex-map
                  :coords="[55.753215, 37.622504]"
                  zoom="10"
                  style="width: 600px; height: 600px;"
                  :controls="['fullscreenControl','zoomControl']"
                  :behaviors="['drag', 'scrollZoom']"
                  :placemarks="placemarks"
                ></yandex-map>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
      <v-divider></v-divider>

      <div v-for="section in sections" :key="section.id" :id="section.id" class="section">
        <v-card>
          <v-layout>
            <!-- <v-flex xs5>
              <v-img :src="coa.photo" height="400px" width="400px" contain></v-img> карта???
            </v-flex>-->
            <v-flex xs12>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">{{ section.name }}</h3>
                  <div class="subheading">{{ section.address }}</div>
                </div>
              </v-card-title>
              <v-card-text>
                <div class="body-1">
                  <span class="body-2">Расписание:</span>
                  <span v-html="section.schedule"></span>
                </div>

                <div class="body-1">
                  <span class="body-2">Тренеры секций:</span>
                  <div v-for="coach in section.coaches" :key="coach.id">
                    <router-link :to="{path: '/coaches', hash: '11'}">{{ coach.name }}</router-link>
                  </div>
                </div>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-card>
        <v-divider></v-divider>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import api from "../api";

export default {
  data() {
    return {
      error: "",
      sections: []
    };
  },
  async created() {
    try {
      this.error = null;
      this.sections = await api.getActiveSections();
    } catch (error) {
      this.error = error.response.data;
    }
  },
  computed: {
    placemarks() {
      return this.sections.map(function(sec) {
        return {
          coords: sec.coords.split(","),
          properties: {
            iconContent: "",
            hintContent: sec.name,
            balloonContent: "",
            balloonContentHeader: sec.name,
            balloonContentBody: sec.schedule
          },
          options: {
            iconColor: "blue"
          }
        };
      });
    }
  },
  methods: {
    getCoachLink(coach) {
      return `/coaches#${coach.id}`;
    }
  }
};
</script>

<style scoped>
.section {
  margin-bottom: 20px;
}
</style>
